/**
 * Delta-V costs (RB §3.2), verbatim.
 *
 * Rule content is data (§10.1): changing a number here changes the game without
 * touching the engine, and the change participates in the content hash so a
 * mid-exercise deploy cannot silently alter a running game.
 */
export const DELTAV_COSTS = Object.freeze({
    /** Automatic, every turn, every orbital asset — including OFFLINE ones (RB §1.1). */
    STATION_KEEPING: 2,
    /** Per slot, maximum 3 slots per turn. */
    PHASE_SHIFT_PER_SLOT: 20,
    PHASE_SHIFT_MAX_SLOTS: 3,
    RPO_APPROACH: 30,
    SHADOW_PER_TURN: 10,
    KKV_TERMINAL_INTERCEPT: 25,
    EVASIVE_MANEUVER: 35,
    BREAK_CUSTODY: 20,
});
/** Unordered band pair key, so LEO→MEO and MEO→LEO share one entry (RB §3.2). */
function pairKey(a, b) {
    return [a, b].sort().join('-');
}
const TRANSFERS = Object.freeze({
    [pairKey('LEO', 'MEO')]: { cost: 120, turns: 2 },
    [pairKey('MEO', 'GEO')]: { cost: 100, turns: 2 },
    [pairKey('LEO', 'GEO')]: { cost: 180, turns: 3 },
    [pairKey('LEO', 'HEO')]: { cost: 150, turns: 2 },
    [pairKey('MEO', 'HEO')]: { cost: 150, turns: 2 },
    [pairKey('GEO', 'HEO')]: { cost: 150, turns: 2 },
});
export function transferCost(from, to) {
    if (from === to)
        return null;
    return TRANSFERS[pairKey(from, to)] ?? null;
}
/** Exported for the content bundle — key order is fixed, so the hash is stable. */
export const TRANSFER_TABLE = TRANSFERS;
//# sourceMappingURL=deltav.js.map